import { CARREGA_CONFIGURACAO_SUCCESS_BACKGROUND } from '../actions/actionTypes';
import initialState from './initialState';

export default function configuracaoReducer(
    state = initialState.configuracao,
    action
) {
    if (action.type === CARREGA_CONFIGURACAO_SUCCESS_BACKGROUND) {
        return action.configuracao;
    }
    return state;
}
